import { createSDK } from "./create";
import { getDeviceInfo } from "./device-detection";
import { getRuntimeReady } from "./ready";

const stub = window.nubeSDK;

// Seed the real SDK with the storefront stub's initial state. The Bootstrap
// snippet bakes `apps`, `location`, etc. into it, so the real SDK starts
// with `state.apps` already populated and `attach()` can spawn workers
// before draining the queue — which is what lets queued events (`init`,
// custom sends) actually reach those workers via the `runtime.on("*")`
// forwarder.
const sdk = createSDK({
	...stub?.getState?.(),
	device: getDeviceInfo(),
});

if (!stub) {
	// No bootstrap stub on the page — expose the real SDK directly. When a
	// stub does exist we leave it in place: the storefront's queuing
	// `on/off/send` must stay active during the async window between runtime
	// load and `attach()` completing. `drainStubQueue` (in attach) replays
	// the queue and swaps the stub's methods for the real ones.
	window.nubeSDK = sdk;
}

// Unblock `attach()`. Awaiting this promise from the register side guarantees
// we never capture the bootstrap stub when load order is reversed.
getRuntimeReady().resolve(sdk);
